export default __webpack_public_path__ + "static/media/JosefinSans-Bold.958fefb3.ttf";